type TenantConfiguration = {
  tokenServiceUrl: string;
  azureApplicationId: string;
  azureTenantId: string;
};

let tenantConfigurationSingleton: TenantConfiguration | null = null;
let pendingConfigurationLoad: Promise<TenantConfiguration> | null = null;

const getTenantConfiguration = () => {
  if (tenantConfigurationSingleton) return Promise.resolve(tenantConfigurationSingleton);
  if (!pendingConfigurationLoad) {
    pendingConfigurationLoad = fetch('/api/tenantconfiguration').then(r => r.json());
    pendingConfigurationLoad
      .then((config) => {
        tenantConfigurationSingleton = config;
      })
      .catch((e) => console.error('Failed to load tenant configurations', e))
      .then(() => {
        pendingConfigurationLoad = null;
      });
  }
  return pendingConfigurationLoad;
};

export default getTenantConfiguration;
